import React from "react";

import { useUserContext } from "../../context/UserContext";
import { useProfilesContext } from "../../context/ProfilesContext";

//Components
import Loading from "../../components/Loading/Loading";
import Admin from "./components/AdminDashboard/AdminDashboard";
import NonAdmin from "./components/NonAdminDashboard/NonAdminDashboard";

export default function Dashboard(props) {
  var admin =useUserContext().userInformation.admin;
  var LoadingScreen = useProfilesContext().loading;

  if (LoadingScreen || admin === null) {
    return(
    <Loading />
    )
  }

  if (!admin) {
    return(
      <NonAdmin history={props.history} />
    )
  }

  if(admin === true) {
    return (
      <>
        <Admin />
      </>
    );
  } 
}